export default class ActualizacionDatosModel {
  image: string="";
  title: string="";
  description: string="";
  terms: string="";
}